export const MaxGroupDescriptionLength = 600;
